<p class="title">{{ 'contact.call_us' | translate }}:</p>
<p>
  <a href="{{ 'contact.href_phone' | translate }}"
    >{{ 'contact.phone' | translate }}</a
  >
</p>
<p class="contact-info">{{ 'contact.opening_times' | translate }}</p>
<p class="title">{{ 'contact.email_us' | translate }}:</p>
<p><a href="mailto:info@li-x.com">info&#64;li-x.com</a></p>
